import { Warning, Info, CheckCircle } from "@phosphor-icons/react";

export const NOTICE_TONES = {
  red: { label: "Urgent / Safety", defaultTitle: "Safety Notice", icon: Warning,
    box: "bg-red-50 border-red-700 text-red-800 dark:bg-red-950/30 dark:border-red-500 dark:text-red-200",
    pill: "bg-red-600 text-white border-red-600", pillOff: "border-red-300 text-red-700 hover:bg-red-50 dark:border-red-800 dark:text-red-300" },
  amber: { label: "Advice", defaultTitle: "Please Note", icon: Info,
    box: "bg-amber-50 border-amber-700 text-amber-800 dark:bg-amber-950/30 dark:border-amber-500 dark:text-amber-200",
    pill: "bg-amber-600 text-white border-amber-600", pillOff: "border-amber-300 text-amber-700 hover:bg-amber-50 dark:border-amber-800 dark:text-amber-300" },
  green: { label: "Positive", defaultTitle: "Good News", icon: CheckCircle,
    box: "bg-emerald-50 border-emerald-700 text-emerald-800 dark:bg-emerald-950/30 dark:border-emerald-500 dark:text-emerald-200",
    pill: "bg-emerald-600 text-white border-emerald-600", pillOff: "border-emerald-300 text-emerald-700 hover:bg-emerald-50 dark:border-emerald-800 dark:text-emerald-300" },
};

const lines = (text) => (text || "").split("\n").map((l) => l.trim()).filter(Boolean);

/* Tinted notice with a darker border; all text in the border colour. Renders nothing without text. */
export function NoticeBox({ notice, className = "", testid = "notice-box", compact = false }) {
  const items = lines(notice?.text);
  if (!items.length) return null;
  const tone = NOTICE_TONES[notice.tone] || NOTICE_TONES.red;
  const Icon = tone.icon;
  return (
    <div className={`rounded-md border-2 ${compact ? "p-3" : "p-4"} ${tone.box} ${className}`} data-testid={testid} data-tone={notice.tone || "red"}>
      <p className={`flex items-center gap-1.5 font-semibold uppercase tracking-[0.15em] ${compact ? "text-[10px]" : "text-[11px]"} mb-1.5`} data-testid={`${testid}-title`}>
        <Icon size={compact ? 13 : 15} weight="fill" /> {notice.title || tone.defaultTitle}
      </p>
      <div className={`${compact ? "text-xs" : "text-sm"} space-y-0.5 font-medium`} data-testid={`${testid}-text`}>
        {items.map((l, i) => (/^[-*•]/.test(l)
          ? <p key={i} className="flex gap-1.5"><span>•</span><span>{l.replace(/^[-*•]\s*/, "")}</span></p>
          : <p key={i}>{l}</p>))}
      </div>
    </div>
  );
}
